<mat-dialog-content>
  {{data.message}}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{'confirmationDialog.cancel' | translate}}</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{'confirmationDialog.confirm' | translate}}</button>
</mat-dialog-actions>